import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  section: {
    marginBottom: '7.2rem',
  },
  sectionTitle: {
    font: {
      size: '1.8rem',
      lineHeight: '2.4rem',
      weight: 700,
    },
    letterSpacing: '0.1rem',
    color: colors.neutral[700],
    textTransform: 'uppercase',
    margin: '0 0 1.6rem 0',
  },
  inactiveEnrollmentsSection: {
    // for app background color, when the more options dropdown is open
    paddingBottom: '10rem',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
